import type { CSSProperties } from "react";

export type TabOption = {
  label: string;
  value: string | number;
};

type TabsProps = {
  options: TabOption[];
  value?: string | number;
  onChange: (value: string | number) => void;
  className?: string;
  activeClassName?: string;
  inactiveClassName?: string;
  activeStyle?: CSSProperties;
  inactiveStyle?: CSSProperties;
  disabled?: boolean;
};

export default function Tabs({
  options,
  value,
  onChange,
  className = "d-flex flex-wrap gap-2",
  activeClassName = "btn-primary",
  inactiveClassName = "btn-outline-primary",
  activeStyle,
  inactiveStyle = { opacity: 0.7 },
  disabled = false,
}: TabsProps) {
  return (
    <div className={className} role="tablist" aria-orientation="horizontal">
      {options.map((option) => {
        const isActive = String(option.value) === String(value ?? "");

        return (
          <button
            key={String(option.value)}
            type="button"
            role="tab"
            aria-selected={isActive}
            className={`btn rounded-pill filter-tab-btn ${isActive ? `is-active ${activeClassName} active` : inactiveClassName}`}
            style={isActive ? activeStyle : inactiveStyle}
            onClick={() => onChange(option.value)}
            disabled={disabled}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}
